import { WINDOW_TYPES } from 'AppConfig/Config/WindowTypes';

const getInitialState = () => ({
    openRequests: [],
    failedRequests: [],
    updatedAt: 0,
    isInitialized: false,
    isApplicationRunning: false,
    activeSideMenuTab: 'dashboard',
    currentWindowMode: WINDOW_TYPES.DESKTOP,
});

export default {
    getInitialState
};
